import {Component, ElementRef, EventEmitter, OnInit, ViewChild, ChangeDetectionStrategy} from '@angular/core';
import {Project} from "../../shared/models/project";
import {Opening} from "../../shared/models/opening";
import {Size} from "../../shared/models/size";
import {MatDialog, MatDialogConfig, MatDialogRef} from "@angular/material/dialog";
import {YesNoDialogComponent} from "../../yesno-dialog/yesno-dialog.component";
import {Shape} from '../../shared/models/shape';
import {MatSelectorComponent} from "../product-selectors/mat-selector/mat-selector.component";
import {ProductSelectorComponent} from "../product-selectors/product-selector/product-selector.component";

@Component({
    selector: 'mbnm-selector-dialog',
    templateUrl: './selector-dialog.component.html',
    styleUrls: ['./selector-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SelectorDialogComponent implements OnInit {

  constructor(public dialog:MatDialog, private dialogRef:MatDialogRef<SelectorDialogComponent>) { }

  project:Project;

  productCategory:any;

  samplesMode:boolean = false;

  sizeHelpInfo:any;

  showSamplesButton:boolean = true;

  selectedProductChange:EventEmitter<any> = new EventEmitter<any>();
  bottomMatChangedBySizeSelector:EventEmitter<any> = new EventEmitter<any>();

  specialInstructions:string;

  onSelectedProductChange(newValues, option) {
    this.selectedProductChange.emit(newValues);
  }

  private _initialProjectProperties:any;

  ngOnInit() {
    if (this.productCategory.type === 'SIZE-SELECTOR') {
      this._initialProjectProperties = {
        bottomMat: this.project.bottomMat,
        size: {
          width: this.project.size.width,
          height: this.project.size.height
        },
        opening: this.project.opening ? {
          width: this.project.opening.size.width,
          height: this.project.opening.size.height,
          shape: this.project.opening.shape
        } : null,
        reveal: this.project.reveal,
        bottomMargin: this.project.bottomMargin,
        complexityUpCharge: this.project.complexityUpCharge,
        instructions: this.project.instructions
      };
    } else if (this.samplesMode) {
      this._initialProjectProperties = {
        samples: this.project.samples.filter((sample) => {
          return sample.type === this.productCategory.type;
        })
      }
    }
  }

  revertChanges():void {
    if (this.samplesMode) {
      this.project.clearSamples(this.productCategory.type);
      this._initialProjectProperties.samples.forEach( (sample) => {
        this.project.addSample(sample);
      });
      this.selectedProductChange.emit(this._initialProjectProperties.samples);
    } else {
      this.project.size.width = this._initialProjectProperties.size.width;
      this.project.size.height = this._initialProjectProperties.size.height;
      if (this._initialProjectProperties.opening) {
        if (this.project.opening) {
          this.project.opening.size.width = this._initialProjectProperties.opening.width;
          this.project.opening.size.height = this._initialProjectProperties.opening.height;
          this.project.opening.shape = this._initialProjectProperties.opening.shape;
        } else {
          const opSize = new Size(this._initialProjectProperties.opening.width, this._initialProjectProperties.opening.height);
          const oval = Shape.fromJson({ code: 'oval', description: 'Oval'});
          const op = new Opening(opSize, [this._initialProjectProperties.ovalCut ? oval : Shape.DEFAULT]);
          this.project.addOpening(op);
        }
      }
      this.project.reveal = this._initialProjectProperties.reveal;
      this.project.bottomMargin = this._initialProjectProperties.bottomMargin;
      this.project.bottomMat = this._initialProjectProperties.bottomMat;

      this.project.complexityUpCharge = this._initialProjectProperties.complexityUpCharge;
      this.project.instructions = this._initialProjectProperties.instructions;
    }
  }

  saveChanges():void {
    if (!this.samplesMode) {
      if (!this.project.bottomMat && this._initialProjectProperties.bottomMat) {
        this.bottomMatChangedBySizeSelector.emit([]);
      } else if (this.project.bottomMat && !this._initialProjectProperties.bottomMat) {
        this.bottomMatChangedBySizeSelector.emit([this.project.bottomMat]);
      }
    }
  }

  showSamplesDialog():void {
    const config = new MatDialogConfig();
    config.panelClass = 'fullscreen';

    const dialogRef = this.dialog.open(YesNoDialogComponent, config);
    dialogRef.componentInstance.data = {
      title: 'Not Sure? Get a Sample!',
      message: '<p>If you\'re not sure you\'ve picked the right product, don\'t worry!</p>' +

      '<p>Individual samples are $1 each and receive a coupon credit for up to <strong>$20 off</strong> your next non-sample purchase.</p>',
      yesButtonText: 'Get Samples',
      noButtonText: 'Close',
    };

    dialogRef.afterClosed().subscribe((results: any) => {
      if (results) {
        this.dialogRef.close("NAVIGATE_TO_SAMPLES");
      }
    });
  }

  availableProductsChanged(productInfo:any):void {
    this.selectAll = productInfo.allSelected;
  }

  @ViewChild('matSelector') matSelector: MatSelectorComponent;
  @ViewChild('productSelector') productSelector: ProductSelectorComponent;
  selectAll = false;
  toggleSelectAll(): void {
    if (this.matSelector) {
      this.matSelector.toggleSelectAllForCurrentGroup(this.selectAll);
    } else if (this.productSelector) {
      this.productSelector.toggleSelectAllForCurrentGroup(this.selectAll);
    }
  }
}
